import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import CoreDtwinStateBridgeMqtt from '@/components/core/dtwin/state/bridge/mqtt';
import CoreDtwinStateBridgeNiota from '@/components/core/dtwin/state/bridge/niota';
import CoreDtwinStateBridgeOpenweather from '@/components/core/dtwin/state/bridge/openweather';
import CoreDtwinStateBridgeSmartservice from '@/components/core/dtwin/state/bridge/smartservice';
import CoreDtwinStateBridgeWebsocket from '@/components/core/dtwin/state/bridge/websocket';
import CoreDtwinStateBridgeIncomingwebhook from '@/components/core/dtwin/state/bridge/incomingwebhook';
export default {
  name: 'CoreDtwinStateBridgeEdit',
  components: {
    CoreDtwinStateBridgeMqtt: CoreDtwinStateBridgeMqtt,
    CoreDtwinStateBridgeNiota: CoreDtwinStateBridgeNiota,
    CoreDtwinStateBridgeOpenweather: CoreDtwinStateBridgeOpenweather,
    CoreDtwinStateBridgeSmartservice: CoreDtwinStateBridgeSmartservice,
    CoreDtwinStateBridgeWebsocket: CoreDtwinStateBridgeWebsocket,
    CoreDtwinStateBridgeIncomingwebhook: CoreDtwinStateBridgeIncomingwebhook
  },
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    // is this an 'edit', 'create'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      selectedBridgeConfig: null,
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), mapState('authentication', ['tenantId'])), {}, {
    hasManageAllPermissions: function hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    baseBridgeType: function baseBridgeType() {
      return (get(this.selectedBridgeConfig, 'type') || '').replace(/^bridge-/, '');
    },
    bridgeComponentExists: function bridgeComponentExists() {
      if (!this.baseBridgeType) {
        return false;
      }

      return this.$options.components["CoreDtwinStateBridge".concat(this.baseBridgeType[0].toUpperCase()).concat(this.baseBridgeType.slice(1))];
    },
    formIsValid: function formIsValid() {
      return (// if a bridge has no UI, mark it as valid in any case
        !this.bridgeComponentExists || !isNullOrEmpty(this.selectedBridgeConfig) && this.$refs["".concat(this.baseBridgeType, "-bridge-config")] && this.$refs["".concat(this.baseBridgeType, "-bridge-config")].formIsValid
      );
    }
  }),
  watch: {
    selectedBridgeConfig: function selectedBridgeConfig(val) {
      var _this = this;

      if (this.lclModel) {
        this.lclModel.properties.binding.options.configId = null;

        if (val && val.configId) {
          this.lclModel.properties.binding.options.configId = val.configId;
          this.lclModel.properties.binding.options.virtualDevice = undefined;
        }
      }

      if (!this.loading) {
        this.$nextTick(function () {
          if (!isNullOrEmpty(_this.$refs.bridgeConfigs)) {
            var dsInput = _this.$refs.bridgeConfig.$el.querySelector('input');

            dsInput.blur();
          }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode === 'create' || this.mode === 'import') {
      if (this.bridgeConfigs && this.bridgeConfigs.length === 1) {
        this.selectedBridgeConfig = this.bridgeConfigs[0];
      }
    } else {
      this.loading = true; // prevent the auto-complete field to be unnecessarily focused (see watcher `selectedBridgeConfig`)

      this.selectedBridgeConfig = this.bridgeConfigs.find(function (ds) {
        return ds.configId === parseInt(_this2.lclModel.properties.binding.options.configId);
      });
    }
  },
  methods: {
    openBridgeConfig: function openBridgeConfig() {
      this.$router.push({
        path: "/connectors/edit/".concat(this.selectedBridgeConfig.tenantId, "/").concat(this.selectedBridgeConfig.configId)
      });
    },
    bridgeBindingChanged: function bridgeBindingChanged(val) {
      this.$emit('bridge-binding-changed', val);
      this.loading = false;
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.configId = get(this.selectedBridgeConfig, 'configId');

      if (this.formIsValid && this.bridgeComponentExists) {
        this.$refs["".concat(this.baseBridgeType, "-bridge-config")].saveState();
      }
    }
  }
};